import { ReactNode, createContext } from 'react';
import { AxiosError } from 'axios';
import utils from 'utils';
import { PopNotificationProps } from './components/PopNotification/PopNotification.component';

export type Notification = Omit<PopNotificationProps, 'notId'> & {
  content: React.ReactNode;
};

type PopNotificationsContextProps = {
  popInfo: (conf: Notification) => void;
  popSuccess: (content: string | ReactNode) => void;
  popError: (content?: string | ReactNode) => void;
  popServerError: (
    error: AxiosError | unknown,
    overrideMessage?: string,
  ) => void;
};

export default createContext<PopNotificationsContextProps>({
  popInfo: utils.noop,
  popSuccess: utils.noop,
  popError: utils.noop,
  popServerError: utils.noop,
});
